import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import { ProductMedia as ProductMediaComponent } from '../../../product-media';
import CampaignBadgeComponent from '../../../../../../components/campaign-badge';
import { H3Text } from '@prisjakt/ui/text/variants';

const mediaImageSize = '100px';

type TitleProps = {
  'data-test': string;
};

export const TitleWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: ${layout.measurements.spacing100};
  flex: 1 0 auto;
`;

export const Title = styled(H3Text).attrs({ container: 'h1' })<TitleProps>`
  margin-bottom: 0px;

  ${media.smallOnly`
    margin-bottom: ${layout.measurements.spacing050}; `}
`;

export const MainSection = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: auto 1fr;
`;

export const StyledRating = styled.div`
  display: inline-block;
  cursor: pointer;
  &:hover span {
    color: ${p => p.theme.text.callToActionHover};
  }
`;

export const ProductMedia = styled(ProductMediaComponent)`
  min-width: ${mediaImageSize};
  margin-right: ${layout.measurements.spacing050};
`;

export const MobileHeader = styled.header`
  ${media.mediumUp`display: none;`}

  display: flex;
  flex-direction: column;
  margin: ${layout.measurements.spacing050};
  row-gap: ${layout.measurements.spacing050};
  border-bottom: 1px solid ${p => p.theme.lines.primary};
  padding-bottom: ${layout.measurements.spacing100};

  ${Title} {
    flex-grow: 1;
  }
`;

export const ListContainer = styled.ul`
  list-style: none;
  margin: 0;
`;

export const CampaignBadge = styled(CampaignBadgeComponent)`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
`;
